import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';

import { BanksCalculator, ConfigService, EstoCalculatorPeriods } from '@speedy/core';

@Injectable({ providedIn: 'root' })
export class CalculatorService {
  constructor(
    protected http: HttpClient,
    protected configService: ConfigService,
  ) {}

  getPeriodsByBank(bankName: string, product_amount: number) {
    const url = 'https://api.esto.ee/v2/calculate/all-payments';

    switch (bankName) {
      case BanksCalculator.Esto:
        return this.http.get<EstoCalculatorPeriods>(url, {
          params: {
            amount: `${product_amount}`,
            shop_id: 'mehka',
          },
        });
      case BanksCalculator.TFBank:
        return this.http.get(url, {
          params: {
            amount: `${product_amount}`,
            shop_id: 'mehka',
          },
        });
      default:
        return EMPTY;
    }
  }

  calculatePaymentByPeriod(bankName: string, period: number, price: number) {
    const url = 'https://api.esto.ee/v2/calculate/payment';

    switch (bankName) {
      case BanksCalculator.Esto:
        return this.http.get<string>(url, {
          params: {
            amount: `${price}`,
            period_months: `${period}`,
          },
        });
      case BanksCalculator.TFBank:
        return this.http.get<string>(url, {
          params: {
            amount: `${price}`,
            period_months: `${period}`,
          },
        });

      case BanksCalculator.Inbank:
        return this.http.post<string>(
          this.configService.getApiUrl() + 'inbank/calculate',
          {
            amount: `${price}`,
            period: `${period}`,
          },
        );
      case BanksCalculator.LHV:
        return EMPTY;
      default:
        return EMPTY;
    }
  }
}
